import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  fehStandaloneFormsStoreSelectorKey,
  reducers,
} from './feh-standalone-forms.state';
import { GeneralAdviceFormEffects } from './effects/general-advice-form.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(fehStandaloneFormsStoreSelectorKey, reducers),
    EffectsModule.forFeature([GeneralAdviceFormEffects]),
  ],
})
export class FehStandaloneFormsStoreModule {}
